import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CanvasContext } from "../../contexts/CanvasContext";
import { FaHome } from "react-icons/fa";
import "./LandingPageNotFound.css";

const PageNotFound = () => {
  const { isDarkTheme } = useContext(CanvasContext);

  return (
    <div className={`page-not-found ${isDarkTheme ? "dark-theme" : ""}`}>
      <div className="background-text">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="text-row">
            404 - PAGE NOT FOUND 404 - PAGE NOT FOUND 404 - PAGE NOT FOUND
          </div>
        ))}
      </div>
      <div className="content">
        <h1 className="heading">404</h1>
        <p className="message">
          Oops! The page you're looking for seems to have vanished into the
          digital void.
        </p>
        <Link to="/" className="home-button">
          <FaHome className="home-icon" />
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;
